import React, { useState, useEffect, useRef } from "react";
import {
  ModalBackdrop,
  ModalCard,
  ModalAccent,
  ModalBody,
  ModalHeader,
  ModalHeaderContent,
  ModalCancelBtn,
  ModalCloseBtn,
  ModalTitle,
  ModalSubtitle,
  ModalFooter,
  FieldGroup,
  FieldLabel,
  FieldError,
  FieldInput,
  ModalCreateBtn,
  FieldHint,
  G,
  IcoX,
  IcoPlus,
} from "./styles";

const CreateSubFolderModal = ({ open, onClose, onCreated, bundleName }) => {
  const [name, setName] = useState("");
  const [prefix, setPrefix] = useState("");
  const [nameError, setNameError] = useState("");
  const [prefixError, setPrefixError] = useState("");
  const nameRef = useRef(null);

  useEffect(() => {
    if (open) {
      setName("");
      setPrefix("");
      setNameError("");
      setPrefixError("");
      setTimeout(() => nameRef.current?.focus(), 80);
    }
  }, [open]);

  if (!open) return null;

  const handleCreate = () => {
    let valid = true;
    if (!name.trim()) {
      setNameError("Sub-folder name is required");
      valid = false;
    }
    if (!prefix.trim()) {
      setPrefixError("Sub-folder prefix is required");
      valid = false;
    }
    if (!valid) return;
    onCreated({ name: name.trim(), code: prefix.trim().toUpperCase() });
    onClose();
  };

  return (
    <ModalBackdrop onClick={onClose}>
      <ModalCard onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalAccent />
          <ModalHeaderContent>
            <ModalTitle>Create Sub-folder</ModalTitle>
            <ModalSubtitle>
              A sub-folder is created inside a Bundle. Tabs placed in the
              sub-folder use your chosen prefix in their stamp.
            </ModalSubtitle>
          </ModalHeaderContent>
          <ModalCloseBtn onClick={onClose}>
            <IcoX size={14} color={G.slate500} />
          </ModalCloseBtn>
        </ModalHeader>
        <ModalBody>
          <FieldGroup>
            <FieldLabel>
              SUB-FOLDER NAME <span className="required-star">*</span>
            </FieldLabel>
            <FieldInput
              ref={nameRef}
              placeholder="e.g. Claimants' Witness Statements"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setNameError("");
              }}
              $error={!!nameError}
            />
            {nameError && <FieldError>{nameError}</FieldError>}
          </FieldGroup>
          <FieldGroup>
            <FieldLabel>
              SUB-FOLDER PREFIX <span className="required-star">*</span>
            </FieldLabel>
            <FieldInput
              placeholder="e.g. CWS"
              value={prefix}
              onChange={(e) => {
                setPrefix(e.target.value.toUpperCase());
                setPrefixError("");
              }}
              $error={!!prefixError}
            />
            {prefixError && <FieldError>{prefixError}</FieldError>}
            {prefix && (
              <FieldHint>
                Tabs in this sub-folder will use this prefix 
                {/* — e.g.{" "}
                <StampExample>{prefix}/1/1</StampExample> */}
              </FieldHint>
            )}
          </FieldGroup>
        </ModalBody>
        <ModalFooter>
          <ModalCancelBtn onClick={onClose}>Cancel</ModalCancelBtn>
          <ModalCreateBtn onClick={handleCreate}>
            <IcoPlus size={12} /> Create
          </ModalCreateBtn>
        </ModalFooter>
      </ModalCard>
    </ModalBackdrop>
  );
};

export default CreateSubFolderModal;
